var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheckboxChecked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 49 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3333 12H15.3333C13.1233 12 11.3333 13.79 11.3333 16V32C11.3333 34.21 13.1233 36 15.3333 36H31.3333C33.5433 36 35.3333 34.21 35.3333 32V16C35.3333 13.79 33.5433 12 31.3333 12ZM21.4033 29.11L16.5833 24.29L18.1033 22.75L21.4033 26.05L28.5333 18.89L30.0833 20.43L21.4033 29.11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0833 20.43L21.4033 29.11L16.5833 24.29L18.1033 22.75L21.4033 26.05L28.5333 18.89L30.0833 20.43Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckboxChecked);
export default __webpack_public_path__ + "static/media/ic-checkbox-checked.6f7e83490d1e5c361b67a7ff50fcd194.svg";
export { ForwardRef as ReactComponent };